import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { QUERY_PARAMS, useAuth, useOnboardingStore } from '#layers/access/public';
import { useSystemInfo } from '#layers/base/public';
import { isUnderTest } from '~/utils/env/is-under-test';
import { isGuestOrPublicRoute } from '~/utils/routes';

export default defineNuxtRouteMiddleware(async (to) => {
	if (isUnderTest())
		return;

	if (isGuestOrPublicRoute(to)) {
		return;
	}

	const onboarding = useOnboardingStore();
	const systemInfo = useSystemInfo();
	const [{ loggedIn }] = await Promise.all([useAuth(), systemInfo.ensureLoaded()]);

	// The probe above races `useAuth`'s token refresh, so it can miss the authenticated section.
	if (loggedIn.value) await systemInfo.ensureAuthenticatedLoaded();

	if (!loggedIn.value) {
		if (onboarding.requireCreateUser) {
			return {
				name: 'onboarding.create-user',
				query: {
					[QUERY_PARAMS.redirect]: to.fullPath,
				},
			};
		}

		return {
			name: 'auth.login',
			query: {
				[QUERY_PARAMS.redirect]: to.fullPath,
			},
		};
	}
});
